import { render, staticRenderFns } from "./up-down.vue?vue&type=template&id=fcf1e2f6&scoped=true&"
import script from "./up-down.js?vue&type=script&lang=js&"
export * from "./up-down.js?vue&type=script&lang=js&"
import style0 from "./up-down.css?vue&type=style&index=0&id=fcf1e2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf1e2f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBadge } from 'vuetify/lib/components/VBadge';
installComponents(component, {VBadge})
